import { Button, Modal, Space } from "antd";
import { useModel, history, useLocation } from "@umijs/max";
import { useEffect, useMemo, useState } from "react";
import ShopExchangeModal from "@/components/Modal/ShopExchangeModal";
import { useLogout } from "@/hooks/useLogout";
import { useSupplyPayeeControllerPostAgreement } from "@/openapi/baob/SupplyPayee.hook";
import { getCurrentUser } from "@/utils/storage";
import { PAGES } from "@/constant/pages";
import { PING_AN_AGREEMENT } from "@/constant/agreement";

/**
 * 鉴权弹窗
 */
const AuthModal = () => {
  const { initialState } = useModel("@@initialState");
  const { pinganCheckData } = useModel("useCommonModel");
  const { setModalModel } = useModel("useModalModel");
  const [open, setOpen] = useState(false);
  const [openShopExchange, setOpenShopExchange] = useState(false);
  const [openAgreement, setOpenAgreement] = useState(false);
  const router = useLocation();
  const logout = useLogout();

  const { mutate: agree } = useSupplyPayeeControllerPostAgreement({
    mutation: {
      onSuccess: () => {
        setOpen(false);
        // 如果账户未鉴权，则进入绑卡鉴权流程，1是0否
        if (pinganCheckData?.is_authentication === 0) {
          history.push(PAGES.CAPITAL_BANK_CARD_SIGN);
        }
      },
    },
  });

  // 已鉴权已签协议，1是0否
  const isAuthedAndAgreed = useMemo(() => {
    return (
      pinganCheckData?.is_authentication === 1 &&
      pinganCheckData?.is_sign_pingan_agreement === 1
    );
  }, [pinganCheckData]);

  // 已鉴权未签协议，1是0否
  const isAuthedNotAgreed = useMemo(() => {
    return (
      pinganCheckData?.is_authentication === 1 &&
      pinganCheckData?.is_sign_pingan_agreement === 0
    );
  }, [pinganCheckData]);

  const handleAgree = () => {
    const { userId, userName, mobile } = getCurrentUser();
    agree({
      baob_user_name: userName,
      baob_user_id: String(userId),
      baob_mobile_phone: mobile,
      ip: (window.returnCitySN && window.returnCitySN.cip) || "",
      supply_ids: pinganCheckData?.need_sign_supply_id,
    });
  };

  const handleViewAgreement = () => {
    setOpenAgreement(true);
  };

  const handleOpenShopExchange = () => {
    if (initialState?.currentUser?.suppliers?.length === 1) {
      logout();
      return;
    }
    setOpenShopExchange(true);
  };

  const handleCloseExchangeModal = () => {
    setOpenShopExchange(false);
  };

  const handleCloseAgreement = () => {
    setOpenAgreement(false);
  };

  useEffect(() => {
    // 如果是鉴权绑卡页面，则不展示这个弹窗
    if (router.pathname === PAGES.CAPITAL_BANK_CARD_SIGN) {
      setOpen(false);
    } else {
      setOpen(!!pinganCheckData && !isAuthedAndAgreed);
      /**
       * 当有鉴权数据时，已授权且同意协议后，当做授权弹窗已弹起处理了
       */
      if (pinganCheckData) {
        setModalModel((prevState) => ({
          ...prevState,
          isAuthModalShown: isAuthedAndAgreed,
        }));
      }
    }
  }, [isAuthedAndAgreed, pinganCheckData, router.pathname, setModalModel]);

  return (
    <Modal
      open={open}
      maskClosable={false}
      closable={false}
      keyboard={false}
      width={440}
      title={isAuthedNotAgreed ? "合作服务协议" : "商家身份信息鉴权"}
      footer={[
        <Space key="footer" className="w-full flex items-center justify-center">
          <Button
            key="back"
            size="large"
            style={{ width: "180px" }}
            onClick={handleOpenShopExchange}
          >
            不同意并退出店铺
          </Button>
          <Button
            key="agree"
            size="large"
            type="primary"
            style={{ width: "180px" }}
            onClick={handleAgree}
          >
            {isAuthedNotAgreed ? "同意协议" : "同意并开始信息鉴权"}
          </Button>
        </Space>,
      ]}
    >
      <div className="h-16 flex flex-row items-center justify-center">
        是否同意
        <Button
          type="link"
          style={{ padding: 0 }}
          onClick={handleViewAgreement}
        >
          <span className="underline">平安银行“平安结算通”商户服务协议</span>
        </Button>
        ？
      </div>
      <ShopExchangeModal
        open={openShopExchange}
        onCancel={handleCloseExchangeModal}
        onOk={handleCloseExchangeModal}
      />
      <Modal
        open={openAgreement}
        title="平安银行“平安结算通”商户服务协议"
        styles={{ header: { marginBottom: "16px" } }}
        width={1000}
        footer={[
          <Space
            key="footer"
            className="w-full flex items-center justify-center"
          >
            <Button
              block={true}
              style={{ width: "160px" }}
              onClick={handleCloseAgreement}
            >
              我已知悉
            </Button>
          </Space>,
        ]}
        onCancel={handleCloseAgreement}
      >
        <iframe
          src={PING_AN_AGREEMENT}
          width="100%"
          height={500}
          style={{ border: "none", borderBottom: "1px solid #eee" }}
        ></iframe>
      </Modal>
    </Modal>
  );
};

export default AuthModal;
